import { z } from "zod";
// TODO: Some params are dependent or exclude others. Extend the schema to reflect that.
export const DTOScimQueryFilterParams = z.object({
    startIndex: z.coerce.number().optional(),
    count: z.coerce.number().optional(),
    filter: z.string().optional(),
    sortBy: z.string().optional(),
    sortOrder: z.enum(["ascending", "descending"]).optional(),
    // attributes: z.string().optional(),
    // excludedAttributes: z.string().optional(),
});
